import type { Lyrics } from 'shared-types/lyrics';

import { s3Client } from './client';

export const getLyrics = async (lyricsUrl: string): Promise<Lyrics> => {
  const textResponse = await s3Client.get(lyricsUrl, true);
  return JSON.parse(textResponse) as Lyrics;
};
